<template>
    <div class="aba-unidade-medida">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-unidade-medida"
                    />
                </div>
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalAssociacaoUnidadeMedida"
                    >
                        {{ $t('vincular-unidade-medida') }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroUnidadeMedida = !showModalCadastroUnidadeMedida"
                    >
                        {{ $t('adicionar-unidade-medida') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assUnidadesMedida"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricao'">
                            <a
                                @click="selectedUnidadeMedidaEdit(props.row)"
                                v-if="!assProdutoUnidadeMedidaIntegracao && permissao.update"
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !assProdutoUnidadeMedidaIntegracao"
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao" @close="fecharModal">
                <div class="bg">
                    <UnidadeMedidaVinculoModal
                        :selected="assUnidadeMedidaSelected"
                        @fecharModal="fecharModal"
                        @sucesso="updateGeral"
                    />
                </div>
            </b-modal>

            <!-- MODAL DE CADASTRO UNIDADE MEDIDA -->
            <b-modal :active.sync="showModalCadastroUnidadeMedida" @close="fecharModal">
                <div>
                    <UnidadeMedidaCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastradaUnidadeMedida"
                        :assProdutoUnidadeMedidaIntegracao="assProdutoUnidadeMedidaIntegracao"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import VenProdutoValidation from '@/services/validations/VenProdutoValidation';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import UnidadeMedidaVinculoModal from '@/components/vendas/produto/modal/dados-cadastrais/unidade-medida/UnidadeMedidaVinculoModal.vue';
import UnidadeMedidaCadastroModal from '@/components/vendas/produto/modal/dados-cadastrais/unidade-medida/UnidadeMedidaCadastroModal.vue';

export default {
    components: {
        UnidadeMedidaVinculoModal,
        UnidadeMedidaCadastroModal,
        ContainerLoader,
    },
    data() {
        return {
            service: null,
            empresaService: null,
            validation: null,
            idpedido: 0,
            unidademedida: {
                /* Colunas da tabela */
                selected: {} /* Un. Medida selecionada atualmente */,
                percentualreajuste: null /* Valor do campo Perc. de Reajuste */,
                fatorConv: null /* Valor do campo Fator de Conv. */,
                disableInputs: false /* Desabilitar os inputs dos campos? */,
            },

            fields: [
                { key: 'descricao', width: null, label: 'descricao', sortable: true },
                { key: 'percentualreajuste', width: null, label: 'perc-reajuste', sortable: true },
                {
                    key: 'fatorconversaoestoque',
                    width: null,
                    label: 'fator-conversao',
                    sortable: true,
                },
                { key: 'situacao', width: 15, label: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', width: 10, sortable: false, sortFn: null },
            ],
            assProdutoUnidadeMedidaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSPRODUTOUNIDADEMEDIDA'
            ),
            unidadeMedidaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'UNIDADEMEDIDA'
            ),
            assUnidadesMedida: [],
            assUnidadesMedidaDisponiveis: [],
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            permissao: false,
            permissaoUnidadeMedida: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '.*',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,

            assUnidadeMedidaSelected: null,
            showModalAssociacao: false,
            showModalCadastroUnidadeMedida: false,
            isUpdate: false,
            modalManage: false,
            permissaoVincular: false,
            permissaoCadastrar: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-unidade-medida'
        );

        this.permissaoUnidadeMedida = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'venda-unidades-medida'
        );

        this.permissaoVincular = this.permissao.create && !this.assProdutoUnidadeMedidaIntegracao;
        this.permissaoCadastrar =
            this.permissaoUnidadeMedida.create && !this.unidadeMedidaIntegracao;

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-un-medida' },
            });

        this.service = new VenProdutoService(this.$http, this.$router);
        this.empresaService = new EmpresaService(this.$http, this.$router);
        this.validation = new VenProdutoValidation(this.msgs);

        this.idproduto = this.$route.params.id;
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.loadTabUnMedida();
    },
    methods: {
        updateGeral() {
            this.$parent.$children.forEach((e) => {
                let name = '' + e.$el.className;
                if (name.includes('aba-geral')) {
                    e.loadUnidadeMedida();
                }
            });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.loadTabUnMedida();
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        loadTabUnMedida(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.service
                .loadUnidadesMedidas(
                    this.idproduto,
                    this.situacaoSelected.id,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.order,
                    this.column,
                    this.queryFilter
                )
                .then((r) => {
                    this.assUnidadesMedida = r.content;
                    this.pagination.totalRows = r.totalElements;
                    this.isEmpty = this.assUnidadesMedida.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar unidade de medida.', e);
                    this.msgs.push(new Message('error', 'msg-erro-un-medida', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.loadTabUnMedida();
        },
        confirmExclusion(item, delFunc, msg) {
            this.$root.confirm({
                message: this.$t(msg ? msg : 'msg-confirmacao'),
                onConfirm: (_) => {
                    delFunc(item);
                },
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 0 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('unidade-medida') }
                );

            let tempAssProdutoUnitMedida = {
                idassprodutounidademedida: this.delete.idassprodutounidademedida,
                idproduto: this.idproduto,
                situacao: this.delete.situacao == 0 ? 1 : 0,
            };

            this.isLoading = true;
            this.service
                .updateSituacaoUnitMedida(tempAssProdutoUnitMedida)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('unidade-medida') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.loadTabUnMedida(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    } else if (r.status == 409) {
                        console.error(r);
                        this.$root.showMessage('alert', this.$t(r.message), true, false);
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        addUnMedida() {
            if (this.validation.validateNovaUnMedida(this.unidademedida)) {
                this.unidademedida.disableInputs = true;

                let um = { ...this.unidademedida.selected };
                um.idproduto = this.produto.idproduto;
                /* Adicionar item no backend */
                this.service
                    .addUnMedida(um)
                    .then((r) => {
                        // Resetar os valores, em caso de sucesso
                        this.unidademedida.selected = {};
                        this.unidademedida.fatorconversaoestoque = null;
                        this.unidademedida.percentualreajuste = null;

                        this.msgs.push(new Message('success', 'msg-success-add-un-medida', true));

                        // Recarregar a aba
                        this.loadTabUnMedida();

                        // Reabilitar a entrada
                        this.unidademedida.disableInputs = false;
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar unidade de medida', e);

                        this.msgs.push(new Message('error', 'msg-erro-add-un-medida', true));

                        // Reabilitar a entrada
                        this.unidademedida.disableInputs = false;
                    });
            }
        },
        showModalUnidadesMedidasNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
            this.isUpdate = false;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.loadTabUnMedida();
            this.isUpdate = false;
            this.showModalCadastroUnidadeMedida = false;
            this.loadTabUnMedida();
        },

        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.loadTabUnMedida(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.loadTabUnMedida(this.pagination.currentPage);
        },

        selectedUnidadeMedidaEdit(selected) {
            this.isUpdate = true;
            this.assUnidadeMedidaSelected = selected;
            this.showModalAssociacao = true;
        },
        cadastradaUnidadeMedida(unidadeMedida) {
            this.showModalCadastroUnidadeMedida = false;
            this.isUpdate = false;
            this.showModalAssociacao = true;
        },
        showModalAssociacaoUnidadeMedida() {
            this.showModalAssociacao = !this.showModalAssociacao;
            this.assUnidadeMedidaSelected = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-unidade-medida {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
